import { ProcedureStateType } from "./procedure-state-type.model"


export class ProcedureFormBase {

    id!: number
    name!: string
    version!: number
    state!: number
    procedureId!: number


    isSuspended(): boolean {
        return this.state == ProcedureStateType.Suspended.valueOf()
    }

    isPublished(): boolean {
        return this.state == ProcedureStateType.Published.valueOf()
    }

    stateToText(state: number = this.state): string {
        switch (state) {
            case 0:
                return "Esborrany"
            case 1:
                return "Revisió"
            case 2:
                return "Publicat"
            case 3:
                return "Suspés"
            case 4:
                return "Inactiu"
        }
        return "Desconegut"
    }

    static from(source: ProcedureForm): ProcedureFormBase {
        let current = new ProcedureFormBase()
        Object.assign(current, source)
        return current
    }

}

export interface ProcedureForm extends ProcedureFormBase { }